// Hint bank (SCRUM-686).
//
// The content lives in bank.json, generated from the per-room drafts in gm-hud/hint-drafts/
// with hint-drafts/tools/md2bank.py. Do not edit bank.json by hand: change the draft and
// regenerate. In the real feature this moves to Postgres with an editor under Admin so content
// people can change hints without a deploy; the shape stays the same.
//
// bank.json is keyed by the room's `game_id` from its games-cloud config (what the WebSocket
// context reports as gameDetailConfig.game_id — "spymaster1", "flugten_6"). Some configs have no
// game_id at all, so each room also lists `aliases`: the HUD route segment / config name
// ("thering", "colombian", "flugten3"). Each room has:
//
//   linear       true when a riddle can only be reached after the previous one
//   situational  hints that belong to the room, not a riddle (kodepanel, "noget har åbnet sig")
//   riddles      in the order players normally meet them. A riddle has:
//     id           stable key; for rooms with props it MUST equal the flow step id the
//                  game-controller reports, so a `solved` flag maps straight onto the riddle
//     title        what the GM sees
//     expectedMin  how long a typical team spends on it (from the activity log: gap between the
//                  median minute of this riddle and the previous one) — drives the time-based
//                  guess and the "they are stuck" nudge
//     medianMin    the raw median minute at which GMs send hints about it
//     keywords     words players tend to use about it in the chat
//     hints        ordered levels 1..3 with `text` (DA) and `en`; the panel offers the next
//                  unsent level first
//     alternatives optional extra guide lines GMs like to send for this riddle

import bank from "./bank.json";

const BY_ALIAS = {};
Object.values(bank).forEach(room => {
    BY_ALIAS[room.gameId] = room;
    (room.aliases || []).forEach(a => { BY_ALIAS[a] = room; });
});

// getHintBank returns the room's bank or null when the room has none (the panel then hides).
// `gameId` is the config's game_id, `routeId` the HUD route segment; either may be missing.
export function getHintBank(gameId, routeId) {
    return BY_ALIAS[gameId] || BY_ALIAS[routeId] || null;
}

export function listHintBanks() {
    return Object.values(bank).map(r => ({ gameId: r.gameId, name: r.name, riddles: r.riddles.length }));
}
